// extracted by mini-css-extract-plugin
export default {"page":"Catering_page__ViVCI"};